/**
 * Created by calhosh on 7/13/2017.
 */
import MotifAccordion from '@ey/motif-react-wrapper/Accordion';
import MotifAccordionContent from '@ey/motif-react-wrapper/AccordionContent';
import MotifAccordionTrigger from '@ey/motif-react-wrapper/AccordionTrigger';
import styled from 'styled-components';
import React from 'react';

export default function Accordion(props) {
	const {
		variant,
		onOpen,
		onClose,
		open,
		accordionHeading,
		children,
		styledName,
		onClick,
		stopPropagation,
		className,
		useChevronIcon,
		alignIconRight
	} = props;

	const dummyCallback = () => {};

	return (
		<StyledMotifAccordion className={`StyledMotifAccordion ${className}`}>
			<MotifAccordion
				useChevronIcon={useChevronIcon}
				alignIconRight={alignIconRight}
				onOpen={onOpen || dummyCallback}
				onClose={onClose || dummyCallback}
				variant={variant}
				open={open}
				className={className}
				onClick={onClick}
			>
				<MotifAccordionTrigger className={styledName}>{accordionHeading}</MotifAccordionTrigger>
				<MotifAccordionContent
					onClick={(e) => {
						stopPropagation && e.stopPropagation();
					}}
				>
					{children}
				</MotifAccordionContent>
			</MotifAccordion>
		</StyledMotifAccordion>
	);
}

const StyledMotifAccordion = styled.section`
	.motif-accordion-content {
		ul.assertions-group-list {
			li {
				display: block;
				border-bottom: var(--px-1) solid var(--neutrals-300);

				&:last-child {
					border-bottom: none;
				}
				&:nth-child(4),
				&:nth-child(5) {
					.show-pop-content.bottom.left {
						left: unset;
						right: unset;
						.show-popup-arrow {
							left: var(--px-18);
							right: unset;
						}
					}
				}
				.AssertionBadge {
					display: flex;
					.motif-checkbox {
						margin-top: var(--px-3);
					}
					padding: var(--px-10) 0;
					.craBadgesWrapper {
						.show-pop-content {
							ul {
								li {
									border: none;
								}
							}
						}
						.assertion {
							padding: var(--px-4);
						}
					}
					.link-item {
						display: inline-block;
						font-size: var(--px-14);
						min-width: 70%;
						max-width: 70%;
						padding-top: var(--px-4);
					}
					span.addedLabel {
						font-size: var(--px-14);
						margin-left: auto;
						padding-right: var(--px-20);
						padding-top: var(--px-4);
					}
				}
			}
		}
	}
`;
